exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".excelUploadBox {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.excelUploadBox .el-input .el-input__inner {\n  width: 2.42rem;\n  border-radius: 0;\n  border-right: 0;\n}\n.excelUploadBox .chooseFile {\n  border-radius: 0;\n  background-color: #2291ff;\n  color: #fff;\n  border: 0.005208rem solid #2291ff;\n  border-left: 0;\n}\n.excelUploadBox .el-upload-list {\n  display: none;\n}", ""]);

// exports
